/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  styleOverrides: {
    root: ({ theme }) => ({
      border: 0,
      borderRadius: 6,
      color: theme.vars.palette.text.secondary,
      fontWeight: 600,
      height: 34,
      lineHeight: 1,
      minWidth: 68,
      padding: '0 14px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: theme.vars.palette.action.hover,
      },
      '&.Mui-selected': {
        backgroundColor: theme.vars.palette.background.paper,
        boxShadow: theme.shadows[1],
        color: theme.vars.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.vars.palette.background.paper,
        },
      },
    }),
  },
};
